import * as XLSX from 'xlsx/xlsx.mjs';

export const downloadReportFunctionality = ({ data }) => {
    const { attendanceReportForMonth } = data

    const fileName = 'Attendance-Report.xlsx'
    const worksheet = XLSX.utils.json_to_sheet(attendanceReportForMonth);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");
    XLSX.writeFile(workbook, fileName)
    const successResponse = "The file should start downloading automatically"
    return successResponse
}